/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "../../../components/ui/button";
import { Separator } from "../../../components/ui/separator";
import fetchData from "../../../utils/api";
import React from "react";
import { Icons } from "../../../components/icons";
import Captcha from "react-google-recaptcha";
import { Config } from "../../../utils/config";
import { getI18n, useTranslation } from "react-i18next";
// import { loadStripe } from "@stripe/stripe-js";

// const stripePromise = loadStripe(Config.env.app.stipe_public_key);

export default function CartFooter({
  total,
  cart_id,
  restaurant_id,
  authToken,
  isOnlinePayment,
  setIsOnlinePayment,
  paymentDetails,
  setPaymentDetails,
  cartList,
  setIsPlaceOrder,
  setIsHeader,
  restaurantDetail,
  minimumOrderAmount,
  subtotal,
  isNotAvailable,
}) {
  const captchaRef = React.useRef<Captcha>(null);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const currentLanguage = getI18n();
  React.useEffect(() => {
    if (isNotAvailable === true) {
      setIsDisabled(true);
      return;
    }
    if (cartList.contactDetails !== null) {
      if (cartList.orderingMethod !== null) {
        if (cartList.orderingMethod?.ordering_method === "pickup") {
          if (
            cartList.pickup !== null &&
            cartList.paymentMethod !== null &&
            cartList?.details?.length > 0
          ) {
            const checkAvailability = cartList.details.find(
              (item) => item.availability !== "in_stock"
            )
              ? false
              : true;

            if (
              cartList.pickup?.method === "as_soon_as_possible" &&
              checkAvailability
            ) {
              setIsDisabled(false);
            } else if (
              cartList.pickup?.date !== undefined &&
              cartList.pickup?.time !== undefined &&
              checkAvailability
            ) {
              setIsDisabled(false);
            }
            if (
              restaurantDetail?.services?.is_min_pickup_amount &&
              restaurantDetail?.services?.min_pickup_amount > subtotal
            ) {
              setIsDisabled(true);
            } else {
              setIsDisabled(false);
            }
          } else {
            setIsDisabled(true);
          }
        } else if (cartList.orderingMethod?.ordering_method === "delivery") {
          if (
            cartList.delivery !== null &&
            cartList.paymentMethod !== null &&
            cartList?.details?.length > 0 &&
            cartList.orderingMethod?.location?.lat !== undefined &&
            cartList.orderingMethod?.location?.lng !== undefined &&
            cartList.orderingMethod?.sso_address !== undefined &&
            cartList.orderingMethod?.title !== undefined &&
            cartList.orderingMethod?.area !== undefined &&
            cartList.orderingMethod?.postal_code !== undefined &&
            cartList.orderingMethod?.street_name !== undefined
          ) {
            const checkAvailability = cartList.details.find(
              (item) => item.availability !== "in_stock"
            )
              ? false
              : true;
            if (checkAvailability) {
              setIsDisabled(false);
            } else {
              setIsDisabled(true);
            }
            if (minimumOrderAmount > subtotal) {
              setIsDisabled(true);
            } else {
              setIsDisabled(false);
            }
          }
        } else if (
          cartList.orderingMethod?.ordering_method === "table_reservation"
        ) {
          if (
            cartList.tableReservation !== null &&
            cartList.tableReservation.person !== undefined &&
            cartList.tableReservation.date !== undefined &&
            cartList.tableReservation.time !== undefined
          ) {
            setIsDisabled(false);
          } else {
            setIsDisabled(true);
          }
        } else if (
          cartList.orderingMethod?.ordering_method === "in_restaurant"
        ) {
          if (
            cartList.tableReservation !== null &&
            cartList.tableReservation.person !== undefined &&
            cartList.tableReservation.date !== undefined &&
            cartList.tableReservation.time !== undefined &&
            cartList.paymentMethod !== null &&
            cartList?.details?.length > 0
          ) {
            const checkAvailability = cartList.details.find(
              (item) => item.availability !== "in_stock"
            )
              ? false
              : true;
            if (checkAvailability) {
              setIsDisabled(false);
            } else {
              setIsDisabled(true);
            }
          }
        } else if (cartList.orderingMethod?.ordering_method === "dine_in") {
          if (
            cartList.dineIn !== null &&
            cartList.paymentMethod !== null &&
            cartList?.details?.length > 0 &&
            restaurantDetail.restaurantMessage.en === ""
          ) {
            const checkAvailability = cartList.details.find(
              (item) => item.availability !== "in_stock"
            )
              ? false
              : true;

            if (checkAvailability) {
              setIsDisabled(false);
            } else {
              setIsDisabled(true);
            }
          }
        } else {
          setIsDisabled(true);
        }
      }
    }
  }, [cartList, isNotAvailable]);

  const { t } = useTranslation();

  const handlePlaceOrder = async () => {
    setIsDisabled(true);
    setIsLoading(true);
    try {
      const utm_parameters = localStorage.getItem("utm_parameters");
      let body;
      if (utm_parameters) {
        body = {
          cart_id: cart_id,
          utm_parameters: utm_parameters,
          language: currentLanguage.language,
        };
      } else {
        body = {
          cart_id: cart_id,
          language: currentLanguage.language,
        };
      }
      const captcha = await captchaRef.current?.executeAsync();
      const res = await fetchData({
        url: "cart/place-order",
        method: "POST",
        body,
        token: authToken,
        captcha: captcha,
        isCaptcha: restaurantDetail?.reCaptcha ?? false,
      });
      if (res.status_code === 200) {
        // if (res.data.client_secret) {
        //   setPaymentDetails({
        //     email: res.data.email,
        //     clientId: res.data.client_secret,
        //   });
        // Revolut
        // if (res.data.token) {
        //   setPaymentDetails({
        //     cart_id: res.data.cart_id,
        //     restaurant_id: res.data.restaurant_id,
        //     restaurant_name: res.data.restaurant_name,
        //     user_details: res.data.user_details,
        //     ordering_method: res.data.ordering_method,
        //     total: res.data.cartTotal,
        //     token: res.data.token,
        //   });

        //   if (res.data.client_secret) {
        //     setPaymentDetails({
        //       email: res.data.email,
        //       clientId: res.data.client_secret,
        //     });
        //     setIsOnlinePayment(true);
        //     // setIsHeader(false);
        //   } else {
        //     setIsPlaceOrder(true);
        //     // setIsHeader(false);
        //   }
        // }
        // if (res.status_code === 200) {
        // Check if online payment is required
        // if (cartList.paymentMethod?.method === "pay_online") {
        //   // If we have session_id for Stripe Checkout
        //   if (res.data.session_id) {
        //     const stripe = await stripePromise;
        //     // Redirect to Stripe Checkout
        //     const redirectResult = await stripe?.redirectToCheckout({
        //       sessionId: res.data.session_id,
        //     });

        //     if (redirectResult?.error) {
        //       console.error("Stripe checkout error:", redirectResult.error);
        //       setIsLoading(false);
        //       setIsDisabled(false);
        //     }
        //   }
        //   // If we still use client_secret (Payment Element)
        // else
        if (res.data.client_secret) {
          setPaymentDetails({
            email: res.data.email,
            clientId: res.data.client_secret,
          });
          setIsOnlinePayment(true);
          // }
        } else {
          // For non-online payments, just complete the order
          setIsPlaceOrder(true);
        }
      }
      //  else {
      //   setIsLoading(false);
      //   setIsDisabled(false);
      //   console.log(res.message);
      //   // Handle error case - maybe show an error toast/message
      // }
      // }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  return (
    <footer className="mt-4">
      <div className="flex justify-center max-w-80 mx-auto">
        <Button
          className=" w-full bg-black"
          disabled={isDisabled}
          onClick={handlePlaceOrder}
          type="button"
        >
          {isLoading && <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />}
          {cartList.orderingMethod?.ordering_method === "in_restaurant"
            ? t("cart.total.table_reservation_place_order")
            : cartList.orderingMethod?.ordering_method === "table_reservation"
            ? t("cart.total.table_reservation")
            : t("cart.total.place_order")}
        </Button>
      </div>
      {restaurantDetail?.reCaptcha === true && (
        <div className="absolute">
          <Captcha
            ref={captchaRef}
            size="invisible"
            sitekey={Config.env.app.recaptcha_key!}
          />
        </div>
      )}
    </footer>
  );
}
